import { render, staticRenderFns } from "./di-exclusions.vue?vue&type=template&id=45e85765&scoped=true"
import script from "./di-exclusions.vue?vue&type=script&lang=js"
export * from "./di-exclusions.vue?vue&type=script&lang=js"
import style0 from "./di-exclusions.vue?vue&type=style&index=0&id=45e85765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e85765",
  null
  
)

export default component.exports